import { render, staticRenderFns } from "./siPurchaseOrdersList.vue?vue&type=template&id=460f8408&scoped=true&"
import script from "./siPurchaseOrdersList.vue?vue&type=script&lang=js&"
export * from "./siPurchaseOrdersList.vue?vue&type=script&lang=js&"
import style0 from "./siPurchaseOrdersList.vue?vue&type=style&index=0&id=460f8408&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460f8408",
  null
  
)

component.options.__file = "siPurchaseOrdersList.vue"
export default component.exports